export const mainSubRating = { id: 0, name: 'Общий рейтинг' }

export const rankingQuery = {
  subRanking: 'subRanking',
}

export const rankingHash = 'ranking'
